"use strict";
import { useTranslation } from "react-i18next";
export const useMenuContent = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("common.company"),
      items: [
        // { label: t('common.careers'), href: 'https://careers.ring.exchange/' },
        { label: t("common.docs"), href: "https://docs.ring.exchange/" }
      ]
    },
    {
      title: t("common.protocol"),
      items: [
        // { label: t('common.vote'), href: 'https://vote.uniswapfoundation.org' },
        { label: t("common.governance"), href: "https://www.tally.xyz/gov/ring" },
        { label: t("common.developers"), href: "https://docs.ring.exchange/docs/integrating" }
      ]
    },
    {
      title: t("common.needHelp"),
      items: [
        // { label: t('common.helpCenter'), href: 'https://support.ring.exchange/hc/en-us' },
        { label: t("common.contactUs.button"), href: "https://discord.com/invite/TefBNDZBQP" }
      ]
    }
  ];
};
